import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 py-8 max-w-7xl" }
const _hoisted_2 = { class: "text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 break-words" }
const _hoisted_3 = { class: "text-[#157813] inline-block" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" }
const _hoisted_6 = {
  key: 1,
  class: "text-gray-500 text-center text-sm sm:text-base uppercase py-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QueryCard = _resolveComponent("QueryCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.inference), 1)
    ]),
    (_ctx.filteredQueries.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQueries, (query) => {
              return (_openBlock(), _createBlock(_component_QueryCard, {
                key: query.id,
                query: query,
                onClick: ($event: any) => (_ctx.showQueryDetails(query.id)),
                class: "w-full"
              }, null, 8, ["query", "onClick"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, " No queries found for this Inference "))
  ]))
}